/* src/app/builder-screen-beta/floating-inspector/property-control.component.scss */
.property-control {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.property-control.compact {
  gap: 6px;
}
.property-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.property-label label {
  font-size: 13px;
  font-weight: 500;
  color: #262626;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}
.compact .property-label label {
  font-size: 12px;
}
.property-label .required-indicator {
  color: #ff4d4f;
  font-weight: bold;
}
.property-label .help-icon {
  color: #8c8c8c;
  font-size: 12px;
  cursor: help;
}
.property-label .help-icon:hover {
  color: #1890ff;
}
.property-input {
  width: 100%;
}
.property-input :host ::ng-deep .ant-input,
.property-input :host ::ng-deep .ant-input-number,
.property-input :host ::ng-deep .ant-select-selector,
.property-input :host ::ng-deep .ant-switch {
  transition: all 0.2s ease;
}
.property-input :host ::ng-deep .ant-input:focus,
.property-input :host ::ng-deep .ant-input-number:focus,
.property-input :host ::ng-deep .ant-select-focused .ant-select-selector {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}
.property-input :host ::ng-deep .ant-input-number {
  width: 100%;
}
.property-input :host ::ng-deep .ant-input-number .ant-input-number-input {
  text-align: left;
}
.property-input :host ::ng-deep .ant-select .ant-select-arrow {
  color: #8c8c8c;
}
.property-input :host ::ng-deep .ant-switch.ant-switch-small {
  min-width: 28px;
  height: 16px;
  line-height: 14px;
}
.property-input :host ::ng-deep .ant-switch.ant-switch-small .ant-switch-handle {
  width: 12px;
  height: 12px;
}
.property-input :host ::ng-deep .ant-switch.ant-switch-small .ant-switch-handle::before {
  border-radius: 6px;
}
.property-input :host ::ng-deep .ant-switch.ant-switch-small.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 12px - 2px);
}
.color-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
.color-input-group :host ::ng-deep .ant-color-picker-trigger {
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  transition: all 0.2s ease;
}
.color-input-group :host ::ng-deep .ant-color-picker-trigger:hover {
  border-color: #40a9ff;
}
.color-input-group :host ::ng-deep .ant-color-picker-trigger:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}
.color-input-group .color-preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  transition: all 0.2s ease;
}
.color-input-group .color-preview:hover {
  border-color: #1890ff;
  transform: scale(1.05);
}
.color-input-group .color-reset {
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.color-input-group .color-reset .anticon {
  font-size: 12px;
}
.property-description small {
  color: #8c8c8c;
  font-size: 11px;
  line-height: 1.4;
  display: block;
}
.property-validation .error-message {
  color: #ff4d4f;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.property-validation .error-message .anticon {
  font-size: 12px;
}
.property-control.compact .property-label label {
  font-size: 12px;
}
.property-control.compact .property-description {
  display: none;
}
.property-control.compact :host ::ng-deep .ant-input,
.property-control.compact :host ::ng-deep .ant-input-number,
.property-control.compact :host ::ng-deep .ant-select-selector {
  font-size: 12px;
}
.property-control.compact :host ::ng-deep .ant-color-picker-trigger {
  width: 28px;
  height: 28px;
}
.property-control.compact .color-input-group .color-preview {
  width: 20px;
  height: 20px;
}
.property-control.compact .color-input-group .color-reset {
  width: 20px;
  height: 20px;
}
.property-input :host ::ng-deep .ant-input,
.property-input :host ::ng-deep .ant-input-number,
.property-input :host ::ng-deep .ant-select,
.property-input :host ::ng-deep .ant-switch,
.property-input :host ::ng-deep .ant-color-picker-trigger {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.property-control:focus-within .property-label label {
  color: #1890ff;
}
@media (max-width: 768px) {
  .property-control {
    gap: 10px;
  }
  .property-control .property-label label {
    font-size: 14px;
  }
  .property-control :host ::ng-deep .ant-input,
  .property-control :host ::ng-deep .ant-input-number,
  .property-control :host ::ng-deep .ant-select-selector {
    font-size: 14px;
    padding: 8px 12px;
  }
  .property-control :host ::ng-deep .ant-switch {
    transform: scale(1.1);
  }
}
/*# sourceMappingURL=property-control.component.css.map */
